import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Logger } from '@common-lib';
import { ActivatedRoute } from '@angular/router';
import { PluginGotenehusRegionsService } from '../../pages-services/plugin-gotenehus-regions.service';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from "@ngx-translate/core";
import { ConfirmPopupComponent } from "../../components/confirm-popup/confirm-popup.component";
import { PluginGotenehusMappingDataService } from 'app/pages-services';

@Component({
  selector: 'app-plugin-gotenehus-regions',
  templateUrl: './plugin-gotenehus-regions.component.html',
  styleUrls: ['./plugin-gotenehus-regions.component.scss']
})
export class PluginGotenehusRegionsComponent implements OnInit {
  editModalRef: BsModalRef;
  selectedRow: {
    id: number,
    regionId: number,
    name: string
  };
  searchTerm = '';

  @ViewChild('editFormTemplate')
  editFormTemplate: TemplateRef<any>;

  tableConfiguration = {
    searchEnabled: false,
    headerEnabled: true,
    orderEnabled: true,
    globalSearchEnabled: false,
    paginationEnabled: true,
    exportEnabled: false,
    clickEvent: false,
    selectRow: false,
    selectCol: false,
    selectCell: false,
    rows: 50,
    additionalActions: false,
    serverPagination: false,
    isLoading: false,
    detailsTemplate: false,
    groupRows: false,
    paginationRangeEnabled: true,
    collapseAllRows: false,
    checkboxes: false
  };

  isSyncing = false;

  columns = [
    { key: 'id', title: 'ID' },
    { key: 'regionId', title: 'Region Id' },
    { key: 'name', title: 'Name' },
    { key: 'actions', title: '' }
  ];

  data = [];
  rows = [];
  selected = new Set();
  selectedLocale = 'en-EN';

  @ViewChild(ConfirmPopupComponent)
  confirmPopup: ConfirmPopupComponent;

  constructor(
    private route: ActivatedRoute,
    private pluginGotenehusRegionsService: PluginGotenehusRegionsService,
    private modalService: BsModalService,
    private logger: Logger,
    private toasterService: ToasterService,
    private translationService: TranslateService,
    private pluginGotenehusMappingDataService: PluginGotenehusMappingDataService,

  ) {
  }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.pluginGotenehusRegionsService.getList().subscribe((data) => {
      this.data = data;
      this.search();
    });
  }

  localeChanged() {
    this.pluginGotenehusRegionsService.getList().subscribe((data) => {
      this.data = data;
      this.search();
    });
  }

  editRow(row) {
    this.selectedRow = row;
    this.editModalRef = this.modalService.show(this.editFormTemplate);
  }

  rowSelected(event) {
    if (event.event === 'onDoubleClick') {
      this.editRow(event.value.row);
    }
  }

  async saveData() {
    let sendObj = Object.assign({}, this.selectedRow);

    if (!sendObj.id) {
      this.pluginGotenehusRegionsService
        .create(sendObj)
        .subscribe(async (result) => {
          this.getList();
          this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_regions.created_message').toPromise());
          this.editModalRef.hide();
        }, (err) => {
          this.toasterService.pop('error', '', err.message);
        });
    } else {
      this.pluginGotenehusRegionsService
        .update(sendObj.id, sendObj)
        .subscribe((result) => {
          this.pluginGotenehusRegionsService
            .getList()
            .subscribe(async (data) => {
              this.data = data;
              this.search();
              this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_regions.updated_message').toPromise());
              this.editModalRef.hide();
            });
        });
    }
  }

  search() {
    this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
      r.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
    );
  }

  addNew() {
    this.selectedRow = {
      id: null,
      regionId: 0,
      name: ''
    };
    this.editModalRef = this.modalService.show(this.editFormTemplate);
  }

  searchKeyPress(event) {
    if (event.which === 13) {
      this.search();
    }
  }

  async removeItem(item) {
    this.selectedRow = item;
    if (this.selectedRow) {
      this.confirmPopup.show();
    }
  }

  confirm(res) {
    if (res) {
      if (this.selectedRow) {
        this.pluginGotenehusRegionsService.delete(this.selectedRow).subscribe(async (resp) => {
          this.selectedRow = null;
          let successMessage = await this.translationService.get('webpanel.plugin_gotenehus_regions.delete.success_message').toPromise();
          this.toasterService.pop('success', '', successMessage);
          this.getList();
        });
      }
    } else {
      this.selectedRow = null;
    }
  }

  decline() {
    this.selectedRow = null;
  }

  syncData() {
    if (!this.isSyncing) {
      this.isSyncing = true;

      this.pluginGotenehusMappingDataService.syncData(['plugin_gotenehus_regions'])
        .subscribe(async ({ success, result }) => {
          this.isSyncing = false;
          const successMessage = await this.translationService
            .get('webpanel.plugin_gotenehus_mapping_data.updated_message')
            .toPromise();
          this.toasterService.pop('success', '', successMessage);
          if (success) {
            this.data = result;
            this.rows = result;
          }
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/plugin-gotenehus-regions/plugin-gotenehus-regions.component.ts